export const filterElement = (layout, key) => {
  const { [key]: value, ...filteredItems } = layout.elements;
  return filteredItems;
};
